export function NoNetwork({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="201"
        viewBox="0 0 200 201"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="mask0_75_52151" maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="201">
          <rect y="0.5" width="200" height="200" fill="white" />
        </mask>
        <g mask="url(#mask0_75_52151)">
          <path
            d="M198.367 184.702C203.191 175.156 189.404 127.426 93.8143 127.426C24.8175 127.426 -6.8502 166.494 0.150891 186.293"
            fill="#4BC9E1"
            fillOpacity="0.1"
          />
          <mask
            id="mask1_75_52151"
            maskUnits="userSpaceOnUse"
            x="5"
            y="127"
            width="201"
            height="60"
          >
            <path
              d="M204.551 184.702C209.374 175.156 195.588 127.426 99.9979 127.426C31.0011 127.426 -0.666608 166.494 6.33448 186.293"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_75_52151)">
            <ellipse
              opacity="0.671968"
              cx="85.257"
              cy="154.193"
              rx="5.25701"
              ry="2.92001"
              fill="var(--clr-general-primary)"
              fillOpacity="0.2"
            />
            <ellipse
              opacity="0.451707"
              cx="141.373"
              cy="161.211"
              rx="8.29439"
              ry="4.55521"
              fill="var(--clr-general-primary)"
              fillOpacity="0.2"
            />
            <ellipse
              opacity="0.729957"
              cx="44.521"
              cy="145.833"
              rx="8.29439"
              ry="4.55521"
              fill="var(--clr-general-primary)"
              fillOpacity="0.2"
            />
          </g>
          <path
            opacity="0.716378"
            d="M87.0309 135.216C83.8072 138.864 96.5643 142.235 120.034 143.026C145.591 149.989 157.205 151.878 161.899 148.279C166.594 144.68 146.441 133.45 130.663 129.902C114.886 126.354 106.218 128.653 96.5452 131.203C95.2355 131.548 95.8851 131.284 92.9138 132.282C89.9425 133.28 87.8148 134.329 87.0309 135.216Z"
            fill="var(--clr-general-primary)"
            fillOpacity="0.2"
          />
          <path
            d="M124.158 111.454C124.158 111.454 114.263 122.476 120.321 129.273C112.607 129.759 107.528 133.441 107.528 133.441L103.327 118.291L124.158 111.454Z"
            fill="#0F606C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.9688 114.586C70.0928 134.475 102.571 134.362 122.655 114.277C142.74 94.192 142.854 61.7142 122.965 41.5901L49.9688 114.586Z"
            fill="var(--clr-general-primary)"
          />
          <ellipse
            cx="86.6854"
            cy="78.7398"
            rx="11.4072"
            ry="51.6158"
            transform="rotate(45 86.6854 78.7398)"
            fill="#58B8C7"
          />
          <mask id="mask2_75_52151" maskUnits="userSpaceOnUse" x="49" y="41" width="76" height="76">
            <ellipse
              cx="86.6854"
              cy="78.7398"
              rx="11.4072"
              ry="51.6158"
              transform="rotate(45 86.6854 78.7398)"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_75_52151)">
            <path d="M101.549 82.0241L80.6285 71.9454V71.9454L88.7037 92.8787" fill="#127F8F" />
          </g>
          <ellipse
            cx="78.6179"
            cy="70.2407"
            rx="7.37369"
            ry="7.39927"
            transform="rotate(-45 78.6179 70.2407)"
            fill="#FFB933"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.1786 64.3811C55.5398 64.3817 55.8606 64.2217 56.101 63.9812C56.3815 63.7008 56.5213 63.3197 56.5006 62.8983C56.2734 58.9046 57.7721 54.9939 60.597 52.169C63.3818 49.3842 67.2523 47.8854 71.2058 48.0724C71.9885 48.0938 72.6698 47.4929 72.6886 46.7103C72.7074 45.9277 72.1043 45.2444 71.3216 45.2231C66.5855 45.0148 61.9328 46.8133 58.587 50.1591C55.2012 53.5449 53.4228 58.2578 53.6714 63.0342C53.7328 63.8169 54.396 64.44 55.1786 64.3811ZM63.9397 67.0108C64.2872 66.961 64.5908 66.8276 64.8093 66.6091C65.0874 66.331 65.2578 65.9054 65.2012 65.4515C64.9239 63.3467 65.5942 61.3153 67.0244 59.885C68.4348 58.4746 70.4251 57.8029 72.4874 58.0377C73.2718 58.1466 73.9713 57.5747 74.0056 56.7747C74.0612 55.996 73.4402 55.2558 72.636 55.1667C69.7283 54.8415 66.9053 55.7929 64.9188 57.7794C62.8728 59.8255 61.9228 62.6896 62.3118 65.6611C62.4207 66.4454 63.1397 67.0451 63.9397 67.0108Z"
            fill="var(--clr-general-primary)"
          />
          <path
            d="M45.2178 62.6572C44.9784 62.8965 44.6596 63.0564 44.2812 63.0771C43.5047 63.0985 42.8687 62.5024 42.8105 61.726C42.5653 54.6585 45.3063 47.7445 50.3133 42.7375C52.842 40.2088 55.7927 38.2737 59.0083 37.0036C59.2605 36.8727 61.4143 36.5686 61.7237 37.4925C62.0331 38.4163 59.971 39.6793 59.971 39.6793C57.1431 40.8098 54.5468 42.518 52.3203 44.7445C47.8719 49.193 45.4509 55.3498 45.6578 61.6608C45.6372 61.9993 45.4771 62.3978 45.2178 62.6572Z"
            fill="var(--clr-general-primary)"
          />
          <mask id="mask3_75_52151" maskUnits="userSpaceOnUse" x="42" y="36" width="20" height="28">
            <path
              d="M45.2178 62.6572C44.9784 62.8965 44.6596 63.0564 44.2812 63.0771C43.5047 63.0985 42.8687 62.5024 42.8105 61.726C42.5653 54.6585 45.3063 47.7445 50.3133 42.7375C52.842 40.2088 55.7927 38.2737 59.0083 37.0036C59.2605 36.8727 61.4143 36.5686 61.7237 37.4925C62.0331 38.4163 59.971 39.6793 59.971 39.6793C57.1431 40.8098 54.5468 42.518 52.3203 44.7445C47.8719 49.193 45.4509 55.3498 45.6578 61.6608C45.6372 61.9993 45.4771 62.3978 45.2178 62.6572Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_75_52151)"></g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M72.9914 33.4914C72.5673 33.0673 71.8797 33.0673 71.4556 33.4914L68.6401 36.3069L65.8251 33.4919C65.4011 33.0678 64.7135 33.0678 64.2894 33.4919C63.8653 33.916 63.8653 34.6036 64.2894 35.0277L67.1043 37.8427L64.2885 40.6584C63.8644 41.0825 63.8644 41.7701 64.2885 42.1942C64.7126 42.6183 65.4002 42.6183 65.8243 42.1942L68.6401 39.3785L71.4564 42.1948C71.8805 42.6189 72.5681 42.6189 72.9922 42.1948C73.4163 41.7707 73.4163 41.0831 72.9922 40.659L70.1759 37.8427L72.9914 35.0272C73.4155 34.6031 73.4155 33.9155 72.9914 33.4914Z"
            fill="#E40219"
          />
        </g>
      </svg>
    </span>
  );
}
